import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const DropdownMenuContent = styled(DropdownMenu.Content)`
  min-width: 200px;
  background-color: white;
  border-radius: 6px;
  padding: 5px;
  box-shadow:
    0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;

  &[data-side='top'] {
    animation-name: slideDownAndFade;
  }
  &[data-side='right'] {
    animation-name: slideLeftAndFade;
  }
  &[data-side='bottom'] {
    animation-name: slideUpAndFade;
  }
  &[data-side='left'] {
    animation-name: slideRightAndFade;
  }
`;

export const DropdownMenuItem = styled(DropdownMenu.Item)`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  line-height: 1;
  border-radius: 3px;
  /* height: 25px; */
  padding: 10px 5px;
  position: relative;
  user-select: none;
  outline: none;

  &[data-disabled] {
    color: ${colors.semantic.disabled};
    pointer-events: none;
  }
  &[data-highlighted] {
    background-color: ${colors.semantic.information.light};
  }
`;

export const DropdownMenuArrow = styled(DropdownMenu.Arrow)`
  fill: white;
`;

export const DropdownMenuStyle = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  .IconButton {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 0 10px 0;
    font-family: inherit;
    border: none;
    background-color: transparent;
  }
  .IconButton:hover {
  }
  .IconButton:focus {
    outline: none;
  }

  @keyframes slideUpAndFade {
    from {
      opacity: 0;
      transform: translateY(2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideRightAndFade {
    from {
      opacity: 0;
      transform: translateX(-2px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideDownAndFade {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideLeftAndFade {
    from {
      opacity: 0;
      transform: translateX(2px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
